package de.oevbs.kunde.kundenportal2.services.account.password.model

import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.account.ChangePassword
import de.oevbs.kunde.kundenportal2.model.services.account.UserName
import de.oevbs.kunde.kundenportal2.services.account.AccountClient
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import dev.fritz2.core.Handler
import dev.fritz2.core.invoke
import dev.fritz2.core.storeOf
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.remote.btoa
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow

class PasswordStore(job: Job) : ValidatingStore<ChangePassword, UserName, ComponentValidationMessage>(
    initialData = ChangePassword(),
    validation = ChangePassword.validation,
    metadataDefault = UserName(),
    validateAfterUpdate = false,
    job = job
) {

    private val progressStore = storeOf(GeneralProgressStep.SUBMIT1, job)
    val progress: Flow<GeneralProgressStep> = progressStore.data

    val submitChangePassRequest: Handler<String> = handle { model, username ->
        GlobalServiceMessagesStore.clear()
        val valid = validate(model, UserName(username)).valid
        if (!valid) return@handle model
        val success = globalSubmitTracker.track {
            changePassword(model)
        }
        if (success) {
            progressStore.update(GeneralProgressStep.SUCCESS2)
            ChangePassword()
        } else model
    }

    private suspend fun changePassword(changePassword: ChangePassword): Boolean {
        tryCatchAndHandleErrors("Ändern des Passworts") {
            AccountClient().changePassword(encodePasswords(changePassword))
        } ?: return false

        return true
    }

    private fun encodePasswords(changePassword: ChangePassword): ChangePassword =
        changePassword.copy(
            currentPassword = btoa(changePassword.currentPassword),
            newPassword = btoa(changePassword.newPassword),
            newPasswordRepeat = btoa(changePassword.newPasswordRepeat),
        )
}